const url = `https://fast.appcues.com/${import.meta.env.VUE_APP_APPCUES_ID}.js`

export function init() {
	if (window.Appcues) {
		//eslint-disable-next-line no-console
		console.warn('AppCues script loaded twice')
		return
	}

	window.AppcuesSettings = {enableURLDetection: true}

	// Create an async script element
	var script = document.createElement('script')
	script.async = true
	script.src = url
	// Insert the script next to the first script element.
	const mountJsBefore = document.getElementsByTagName('script')[0] || document.body.firstChild
	mountJsBefore.parentNode.insertBefore(script, mountJsBefore)
}
